export enum FunnelStep {
  LandingPage,
  Step1,
  Step2,
  Step3,
  Step4,
  Upsell,
  ThankYouPage,
  Decline,
}
